import { defineMessages } from 'react-intl'

const scope = `procurify.platform.integrations.pages.quickBooksDesktop`

export default defineMessages({
  pageTitle: {
    id: `${scope}.pageTitle`,
    defaultMessage: 'QuickBooks desktop',
  },
  settingsTitle: {
    id: `${scope}.settingsTitle`,
    defaultMessage: 'Settings',
  },
  integrationsTitle: {
    id: `${scope}.integrationsTitle`,
    defaultMessage: 'Integrations',
  },
})
